import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Aux from "../../Aux/Aux";
import Calendar from "../../../container/Calendar/Calendar";
import Files from "../../../container/Files/Files";
import BulkUpload from "../../../components/BulkUpload/BulkUpload";
import UserProfile from "../../../container/UserProfile/UserProfile";
import ArchivedExplorer from "../../../container/ArchivedExplorer/ArchivedExplorer";
import LoginScreens from "../../../container/LoginScreens/LoginScreens";
import ValidateUser from "../../../components/UserManagement/ValidateUser";
import PrivateRoute from "../../../AuthRoutes/PrivateRoute";
import Feed from "../../../container/Feed/Feed";
import AdminSettings from "../../../container/AdminSettings/AdminSettings";

const body = (props) => {
  const getUserRoleBasedRoutes = (userRoleId) => {
    const commonRoutes = (
      <>
        <PrivateRoute exact path="/archives" component={ArchivedExplorer} />
      </>
    );

    if (userRoleId === 1 || userRoleId === 2) {
      // Admin or IT Admin
      return (
        <>
          {commonRoutes}
          <PrivateRoute
            exact
            path="/admin-settings"
            component={AdminSettings}
          />
        </>
      );
    } else if (userRoleId === 3 || userRoleId === 4 || userRoleId === 5) {
      // Manager
      return commonRoutes;
    }

    return null;
  };

  return (
    <Aux>
      <Switch>
        <Route exact path="/validate/:token" component={ValidateUser} />
        <PrivateRoute exact path="/feed" component={Feed} />
        <PrivateRoute exact path="/calendar" component={Calendar} />
        <PrivateRoute exact path="/files" component={Files} />
        <PrivateRoute exact path="/archives" component={ArchivedExplorer} />
        <PrivateRoute
          exact
          path="/archives/:folderId"
          component={ArchivedExplorer}
        />
        <PrivateRoute
          exact
          path="/archives/:folderId/:subId"
          component={ArchivedExplorer}
        />
        <PrivateRoute 
          exact 
          path="/archives/:folderId/:subId/:docId" 
          component={ArchivedExplorer} />
        <PrivateRoute
          exact
          path="/admin-settings"
          component={AdminSettings}
          {...props}
        />
        <PrivateRoute exact path="/files/:folderId" component={Files} />
        <PrivateRoute path="/user-profile" component={UserProfile} />
        
        <PrivateRoute
          path="/files/:folderId/:subFolderId/bulk-upload"
          component={BulkUpload}
        />
        <PrivateRoute exact path="/files/:folderId/:subId/:docId" component={Files} />
        <PrivateRoute exact path="/files/:folderId/:subId" component={Files} />

        <Route exact path="/login" component={LoginScreens} />
        <Route exact path="/sign-up" component={LoginScreens} />
        <Route exact path="/reset-password/:token" component={LoginScreens} />
        <Route exact path="/reset-password" component={LoginScreens} />
        <Route exact path="/forgot-password" component={LoginScreens} />
        <Route exact path="/create-account/:token" component={LoginScreens} />
        <Redirect
          exact
          from="/"
          to={
            props.currentUserId === 1
              ? "/feed"
              : parseInt(props.currentUserId) === 2
              ? "/feed"
              : parseInt(props.currentUserId) === 3
              ? "/feed"
              : props.currentUserId === 4
              ? "/feed"
              : parseInt(props.currentUserId) === 5
              ? "/feed"
              : "/"
          }
        />
        <Redirect
          exact
          from="/*"
          to={
            props.currentUserId === 1
              ? "/feed"
              : parseInt(props.currentUserId) === 2
              ? "/feed"
              : parseInt(props.currentUserId) === 3
              ? "/feed"
              : props.currentUserId === 4
              ? "/feed"
              : parseInt(props.currentUserId) === 5
              ? "/feed"
              : "/"
          }
        />
        {getUserRoleBasedRoutes(props.currentUserId)}
      </Switch>
    </Aux>
  );
};

export default body;
